import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import { PageProvider } from './contexts/PageContext';

import PublicLayout from './components/PublicLayout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import PricingPage from './pages/PricingPage';
import SecurityPage from './pages/SecurityPage';
import ContactPage from './pages/ContactPage';
import ThankYouPage from './pages/ThankYouPage';
import { TermsPage, PrivacyPage, CookiesPage } from './pages/LegalPages';
import NotFoundPage from './pages/NotFoundPage';
import BlogListPage from './pages/BlogListPage';
import BlogDetailPage from './pages/BlogDetailPage';

import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import { AdminPagesList, AdminPageEditor } from './pages/admin/AdminPages';
import { AdminLanguages, AdminCountries } from './pages/admin/AdminLangCountry';
import { AdminUsers, AdminRoles, AdminContacts } from './pages/admin/AdminUsersRoles';
import { AdminArticlesList, AdminArticleEditor } from './pages/admin/AdminArticles';

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <PageProvider>
            <BrowserRouter>
              <Routes>
                <Route element={<PublicLayout />}>
                  <Route index element={<HomePage />} />
                  <Route path="about" element={<AboutPage />} />
                  <Route path="services" element={<ServicesPage />} />
                  <Route path="pricing" element={<PricingPage />} />
                  <Route path="security" element={<SecurityPage />} />
                  <Route path="contact" element={<ContactPage />} />
                  <Route path="thank-you" element={<ThankYouPage />} />
                  <Route path="blog" element={<BlogListPage />} />
                  <Route path="blog/:slug" element={<BlogDetailPage />} />
                  <Route path="terms" element={<TermsPage />} />
                  <Route path="privacy" element={<PrivacyPage />} />
                  <Route path="cookies" element={<CookiesPage />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Route>

                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="pages" element={<AdminPagesList />} />
                  <Route path="pages/:key" element={<AdminPageEditor />} />
                  <Route path="articles" element={<AdminArticlesList />} />
                  <Route path="articles/new" element={<AdminArticleEditor />} />
                  <Route path="articles/:slug" element={<AdminArticleEditor />} />
                  <Route path="languages" element={<AdminLanguages />} />
                  <Route path="countries" element={<AdminCountries />} />
                  <Route path="users" element={<AdminUsers />} />
                  <Route path="roles" element={<AdminRoles />} />
                  <Route path="contacts" element={<AdminContacts />} />
                  <Route path="*" element={<Navigate to="/admin" replace />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </PageProvider>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
